module.exports = __webpack_public_path__ + "img/arrow-right-from-bracket.626e14dc.svg";